window.addEventListener("DOMContentLoaded", function(){

// const el = document.querySelector(".template-index");
// console.log( el );

//   if ( document.querySelector("body.template-index")){
//     console.log( document.querySelector("body.template-index"));

  const headerElement = document.getElementById("shopify-section-header");

  document.addEventListener("scroll", function () {
    const scrollY = window.pageYOffset;
    //   console.log(scrollY);
    if (scrollY > 600) {
      headerElement.classList.add("active");
      //    document.getElementById('shopify-section-header').classList.add('active');
    } else {
      headerElement.classList.remove("active");
      // 	document.getElementById('shopify-section-header').classList.remove('active');
    }
  });

//    const images = [
//     'https://cdn.shopify.com/s/files/1/0563/1403/6384/files/IMG_1100s.jpg?v=1623646839',
//     'https://cdn.shopify.com/s/files/1/0563/1403/6384/files/render2.jpg?v=1623202071'
//   ];

//   let currentIndex = 0;
//   const mainImage = document.getElementById('carousel_main');
// mainImage.src = images[currentIndex];
// // console.log(mainImage);
//   for ( let [index, image] of images.entries()){
// // 	console.log(index,image);

//   };

//   リロードする度に画像を入れ替えるJS
  if ( document.querySelector("body.template-index") || document.querySelector("body.template-product")  ) {
	const imglist = [
        "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/wagara_s.jpg?v=1626694453"
//       "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/04.jpg?v=1625027940",
//       "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/05.jpg?v=1625027966",
//       "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/06.jpg?v=1625027987",
//       "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/07.jpg?v=1625028011",
//       "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/08.jpg?v=1625028035",
//       "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/09.jpg?v=1625028056",
//       "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/10.jpg?v=1625028081",
//       "https://cdn.shopify.com/s/files/1/0563/1403/6384/files/11.jpg?v=1625028104"
    ]

	const imgElement = document.createElement("img")
    imgElement.setAttribute("src" , imglist[Math.floor(Math.random() * imglist.length)] )
	document.getElementById("target").appendChild(imgElement)

  } //end

//   if ( document.querySelector(“body.template-index”)　) {
//     document.querySelectorAll(“.price-item”).classList.add(".hidden")
//     }

//   import { IntersectingCirclesSpinner } from 'epic-spinners'
//     <intersecting-circles-spinner
//     :animation-duration="1200"
//     :size="70"
//     color="#ff1d5e"
//     />
});
